import { useTrack } from '@sortlist-frontend/tracking';
import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRadarTracker } from '@sortlist-frontend/user-tools';
import { getStorage } from '@sortlist-frontend/utils';
import { Fragment, useEffect, useState } from 'react';

import { BriefingButton } from '_components/Briefing/versions/NormalBriefing/button';
import { Obfuscate } from '_components/common/Obfuscate/Obfuscate';
import { usePublicAppContext } from '_core/context/public-app-context';
import { agencyProfileConfig } from '_features/AgencyProfile/config';

export type SecondaryCTAProps = {
  agencyWebsite: string | null;
  brandingModule: 'value_based' | 'free';
  agencySlug: string;
  agencyUuid: string;
};

export const SecondaryCTA = (props: SecondaryCTAProps) => {
  const { agencyWebsite, brandingModule, agencySlug, agencyUuid } = props;
  const { locale } = usePublicAppContext();
  const { t } = useTranslation(agencyProfileConfig.i18nNamespaces);
  const [sessionEntryUrl, setSessionEntryUrl] = useState('');
  const { track } = useTrack({ app: 'public', locale });
  const { track: radarTrack } = useRadarTracker();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const url = getStorage('sessionEntryUrl') || window.location.href;
      setSessionEntryUrl(url.replace(/"/g, ''));
    }
  }, []);

  const trackOpenWebsite = () => {
    track({
      slug: 'websiteOpened',
      data: {
        agencySlug,
        agencyUuid,
        page: 'agency-profile',
        element: 'about-section',
        pageType: 'agency-profile',
        htmlElementTrigger: 'about-section',
      },
    });
    radarTrack({
      eventName: 'websiteVisited',
      properties: {
        agency_slug: agencySlug,
      },
    });
  };

  return (
    <Fragment>
      {brandingModule === 'value_based' ? (
        <Obfuscate
          className="text-center btn btn-light btn-md btn-primary"
          obfuscate={true}
          role="button"
          href={`${agencyWebsite}?utm_source=sortlist&utm_medium=profile&utm_campaign=${encodeURIComponent(sessionEntryUrl)}`}
          onClick={trackOpenWebsite}
          target="_blank"
          data-testid="openWebsite">
          {t('agency:profile.about.openWebsiteCta')}
        </Obfuscate>
      ) : (
        <BriefingButton
          data-testid="compareAgencies"
          cta="about-panel"
          truncate={false}
          buttonStyle="primary"
          buttonVariant="light"
          size="md"
          className="text-center"
          label={t('agency:profile.about.compareCta')}
        />
      )}
    </Fragment>
  );
};
